import React, { useState } from "react";
import axios from 'axios';
import * as API from "../../Endpoints/Endpoints";
import { useNavigate } from 'react-router-dom';

const AddNetwork = () => {
  const [formData, setFormData] = useState({
    subtype: "",
    subname: "",
    currency: "",
    description: "",
    level1: "",
    level2: "",
    level3: "",
    level4: "",
  });

  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      const response = await axios.post(API.POST_NETWORK_API, formData, {
        headers: { "Content-Type": "application/json" },
      });

      if (response.status === 201) {
        console.log("Form Data Submitted Successfully:", response.data);
        setFormData({
          subtype: "",
          subname: "",
          currency: "",
          description: "",
          level1: "",
          level2: "",
          level3: "",
          level4: "",
        });
        alert("Data submitted successfully!");
        navigate('/networktable');
      } else {
        alert("Failed to submit data.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting data.");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="mt-4 w-full max-w-md p-8 bg-white rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-700 mb-6">
          Subscription Form
        </h2>
        <form onSubmit={handleSubmit}>
          {[
            { id: "subtype", label: "Subscription Type", placeholder: "Enter subscription type" },
            { id: "subname", label: "Subscription Name", placeholder: "Enter subscription name" },
            { id: "currency", label: "Currency", placeholder: "Enter currency" },
            { id: "description", label: "Description", placeholder: "Enter description" },
            { id: "level1", label: "Level 1", placeholder: "Enter level 1" },
            { id: "level2", label: "Level 2", placeholder: "Enter level 2" },
            { id: "level3", label: "Level 3", placeholder: "Enter level 3" },
            { id: "level4", label: "Level 4", placeholder: "Enter level 4" },
          ].map(({ id, label, placeholder }) => (
            <div className="mb-4" key={id}>
              <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1">
                {label}
              </label>
              <input
                type="text"
                id={id}
                name={id}
                value={formData[id]}
                onChange={handleChange}
                placeholder={placeholder}
                className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
                required
              />
            </div>
          ))}
          <button
            type="submit"
            className="w-full bg-[#e64a32] text-white py-2 px-4 rounded-lg hover:[#e64a32] focus:outline-none"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default AddNetwork;
